<script setup lang="ts">
import TypographyComponent from './TypographyComponent.vue'

withDefaults(defineProps<{ size?: 'small' | 'medium' }>(), { size: 'medium' })
</script>
<template>
  <div class="thumbnail-only-badge" role="note">
    <TypographyComponent
      :is="'span'"
      :variant="size === 'small' ? 'body-small' : 'body-medium'"
      color="var(--secondary-48)"
      text-align="center"
    >
      No video available (thumbnail only)
    </TypographyComponent>
  </div>
</template>
<style scoped lang="scss">
.thumbnail-only-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  max-width: calc(100% - 24px);
  padding: 8px 16px;
  border-radius: 40px;
  background-color: rgba(255, 255, 255, 0.64);
  backdrop-filter: blur(4px);
  text-align: center;
}
</style>
